import React, { Component } from 'react';
import * as firebase from 'firebase';
import ReactDOM from 'react-dom';
import { Link, NavLink } from 'react-router-dom';
import BrowserDetection from 'react-browser-detection';
import Logo from '../images/logo.svg';
import '../css/header.css'
import Photo from '../images/自我肯定-350.gif';

const browserHandler = {
  ie: () => <div style={{display: 'fixed', height: '100vh', background: 'rgba(0,0,0,.8)'}} >
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
      <img  style={{marginTop: 150, display: 'block'}} src={Photo} alt="草學藥事" />
      <p style={{color: '#fff'}}>我們堅持給您最好的體驗 <br />
       重複測試證明, IE瀏覽器對於效能與樣式都會有無法預期的問題!!<br />
      </p>
      <h1 style={{color: '#fff'}} >請使用IE以外的瀏覽器進行體驗~謝謝</h1>
    </div>
  </div>,
  default: (browser) => <div style={{display: 'none'}} >Hi {browser}!</div>
};

class MobileNav extends Component {
  constructor() {
    super();
    this.state = {
      MTPostCount: false
    }
  }
  componentDidMount() {
    const getMTPostRef = firebase.database().ref('faq/')
    getMTPostRef.on('value', snap => {
      this.setState({
       MTPostCount: snap.numChildren()
      })
    })
  }
  render() {
    return(
      <div style={Jeyu.lightbox}>
       <div style={Jeyu.mobilenavinfo} className="mobilenavinfo">
        <NavLink to="/">體質檢測</NavLink>
        <NavLink to="/MedicalTeam">健康達人</NavLink>
        <NavLink to="/FaqLists" style={{position: 'relative'}} >有事就問
         <sup style={{display: this.state.MTPostCount ? 'block' : 'none', position:'absolute', top: '-5px', right: '-15px', color: '#fff', background:'#23C7C9', fontSize: 11, padding: '0 3px'}}>
              {this.state.MTPostCount}
         </sup>
        </NavLink>
       </div>
      </div>
    )
  }
}

export default class Header extends Component {
  constructor() {
    super();
    this.state = {
      showReply: false,
      email: '',
      displayName: '',
      photoURL: '',
      totalTest: '',
      MTPostCount: false
    }
    this.toggle = this.toggle.bind(this);
  }
  toggle(e) {
    e.preventDefault()
    this.setState({showReply: !this.state.showReply})
  }
  componentDidMount() {

  firebase.auth().onAuthStateChanged((user) => {
   const checkLogin = ReactDOM.findDOMNode(this.refs.checkLogin)
   if (user) {
     var userId = firebase.auth().currentUser.uid
     firebase.database().ref('users/' + userId + '/UserProfile/').update({
       email: user.email,
       displayName: user.displayName,
       photoURL: user.photoURL
     });
     checkLogin.classList.add('isLogin')
     const rootRef = firebase.database().ref('users/').child(userId).child('UserProfile')
     rootRef.on('value', snap => {
       this.setState({
         email: snap.val().email,
         displayName: snap.val().displayName,
         photoURL: snap.val().photoURL
       })
     })
   } else {
     checkLogin.classList.remove('isLogin')
   }
  })
  const getMTPostRef = firebase.database().ref('faq/')
  getMTPostRef.on('value', snap => {
    this.setState({
     MTPostCount: snap.numChildren()
    })
  })
 }
 componentWillUnmount() {
 firebase.auth().onAuthStateChanged((user) => {
  const checkLogin = ReactDOM.findDOMNode(this.refs.checkLogin)
  if (user) {
    var userId = firebase.auth().currentUser.uid
    firebase.database().ref('users/' + userId + '/UserProfile/').update({
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL

    });
    checkLogin.classList.add('isLogin')
    const rootRef = firebase.database().ref('users/').child(userId).child('UserProfile')
    rootRef.on('value', snap => {
      this.setState({
        email: snap.val().email,
        displayName: snap.val().displayName,
        photoURL: snap.val().photoURL
      })
    })
  } else {
    console.log('error')
    checkLogin.classList.remove('isLogin')
  }
 })

}

handleNotLogin() {
  window.location = ('/UserProfile/Personal')
}

  render() {

    return(
      <div className="header">
       <div className="container">
        <div className="row flex">
         <div className="col-xs-12 col-sm-3 col-md-2 col-lg-2"><Link to="/"><img src={Logo} alt="草學藥事" style={Jeyu.Logo} /></Link></div>
         <div className="col-xs-12 col-sm-9 col-md-10 col-lg-10">
          <nav style={Jeyu.Nav} className="pcMobile">
           <NavLink exact to="/" >體質檢測</NavLink>
           <NavLink to="/MedicalTeam">健康達人</NavLink>
           <NavLink to="/FaqLists" style={{position: 'relative'}}>有事就問
           <sup style={{display: this.state.MTPostCount ? 'block' : 'none', position:'absolute', top: '-5px', right: '-15px', color: '#fff', background:'#23C7C9', fontSize: 11, padding: '0 3px'}}>
              {this.state.MTPostCount}
            </sup>
           </NavLink>
          </nav>
          <div className="pcMobileBox">
          <span  className="btnLogin" ref="checkLogin" onClick={this.handleNotLogin} >登入</span>
          <Link to="/UserProfile/Personal" className="logOutPhotobox"><img style={Jeyu.userPhoto} alt={this.state.photoURL} src={this.state.photoURL} /></Link>
          </div>

          <div className="navMobile">
           <a onClick={this.toggle}>
            <div style={Jeyu.mobilemenu}></div>
            <div style={Jeyu.mobilemenu}></div>
            <div style={Jeyu.mobilemenu}></div>
           </a>
           <div onClick={this.toggle}>
            {this.state.showReply && <MobileNav />}
           </div>
          </div>
          </div>
         </div>
        </div>
        <BrowserDetection>
         { browserHandler }
        </BrowserDetection>
       </div>
    )
  }
}

const Jeyu = {
  Logo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  Nav: {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center'
  },
  mobilemenu: {
   height: 3,
   width: 25,
   background: '#333',
   margin: '5px 0'
  },
  lightbox: {
   background: 'rgba(0,0,0,.8)',
   height: '100vh',
   position: 'fixed',
   width: '100%',
   zIndex: 9,
   left: 0,
   top: 0
  },
  mobilenavinfo: {
   margin: '20% 0 0 30px',
 },
 userPhoto: {
  width: 45,
  height: 45,
  overflow: 'hidden',
  borderRadius: 77,
  display: 'inline-block'
 }
}



// WEBPACK FOOTER //
// ./src/Layout/Header.js